import TemplateView from '../TemplateView'
import CompletedTaskStatusMenu from '../controls/task/CompletedTaskStatusMenu'
import TaskStatusButton from '../controls/task/TaskStatusButton'

export default class MoveToArchivedConfirmationDialog extends TemplateView {
    constructor({
        confirmCallback = ({customer, project, withRestore, workflowStatusId}) => {},
        cancelCallback = () => {},
        initStatusMenuTo = null,
    }) {
        super()

        this.params = {
            initStatusMenuTo,
        }

        this.callbacks = {
            confirmCallback,
            cancelCallback,
        }

        this.state = {
            customer: null,
            project: null,
            workflowStatusId: null,
            withRestoreOption: false,
            completeOptionSelected: true,
            canEditTaskStatus: true,
            isTWSEnabled: false,

            title: '',
            singleOptionDescription: '',
            multiOptionDescription: '',
            archiveText: '',
            restoreText: '',
            showRestoreNote: false,
        }

        this.onStatePropertyChanged("completeOptionSelected", this._updateRadio)

        this.onStatePropertyChanged("title", () => this.$title.text(this.state.title))

        this.onStatePropertyChanged("archiveText", () => this.$archiveText.text(this.state.archiveText))

        this.onStatePropertyChanged("restoreText", () => this.$restoreText.text(this.state.restoreText))

        this.onStatePropertyChanged("showRestoreNote", () => this.$restoreNote.toggle(this.state.showRestoreNote))

        this.onStatePropertyChanged("canEditTaskStatus", (canEditTaskStatus) => {
            if (this.singleStatusButton && this.singleStatusButton.setEditable) {
                this.singleStatusButton.setEditable(canEditTaskStatus)
            }

            if (this.radioStatusButton && this.radioStatusButton.setEditable) {
                this.radioStatusButton.setEditable(canEditTaskStatus)
            }
        })


        this.onStatePropertyChanged("workflowStatusId", (workflowStatusId) => {
            this.radioStatusButton.setState({statusId: workflowStatusId})
            this.singleStatusButton.setState({statusId: workflowStatusId})
        })

        this.onAnyStatePropertyChanged(['withRestoreOption', 'isTWSEnabled'], () => {
            this.$description.toggle(this.state.withRestoreOption || this.state.isTWSEnabled)
            this.$radioSection.toggle(this.state.withRestoreOption)
            this.$statusButton.toggle(!this.state.withRestoreOption && this.state.isTWSEnabled)
            this.radioStatusButton.toggle(this.state.withRestoreOption && this.state.isTWSEnabled)

            this._updateDescriptionText()
        })

        this.onAnyStatePropertyChanged(['withRestoreOption', 'singleOptionDescription', 'multiOptionDescription'], () => this._updateDescriptionText())
    }

    templateHtml() {
        return `
        <div class='moveToArchivedConfirmationDialog'>
            <div class='flexWrapper'>
                <div class='title'/>
                <div class='description'/>
                <div class='statusSelector single'/>
                <div class='radioSection'>
                    <label>
                        <div class='completeWithStatus radioOption'>
                            <input type='radio' class='complete' checked/>
                            <div class='archiveText'/>
                            <div class='statusSelector radio'/>
                        </div>
                    </label>
                    <label>
                        <div class='restoreFromArchive radioOption'>
                            <input type='radio' class='restore'/>
                            <div class='restoreTextContainer'>
                                <div class='restoreText'/>
                                <div class='restoreNote'><%-restoreNote%></div>
                            </div>
                        </div>
                    </label>
                </div>
                <div class='separator'/>
                <div class='buttonsContainer'>
                    <div class='move button'><%=moveLabel%></div>
                    <div class='cancel button'><%=cancelLabel%></div>
                </div>
            </div>
        </div>
        `
    }

    afterRender() {

        this.$title = this.find(".title")

        this.$description = this.find(".description")
        this._updateDescriptionText()

        this.$archiveText = this.find(".archiveText")
        this.$restoreText = this.find(".restoreText")
        this.$restoreNote = this.find(".restoreNote")

        this.$statusButton = this.find(".statusSelector.single")
        this.singleStatusButton = this._createTaskStatusButton(this.$statusButton)

        this.$radioSection = this.find(".radioSection")
        this.radioStatusButton = this._createTaskStatusButton(this.find(".statusSelector.radio"))
        this.radioStatusButton.setState({canReopenProject: true})

        this.$completeWithStatusOption = this.find(".completeWithStatus")
        this.$completeWithStatusRadio = this.$completeWithStatusOption.find(".complete").on('change', () => this.setState({completeOptionSelected: true}))
        this.$restoreFromArchiveOption = this.find(".restoreFromArchive")
        this.$restoreFromArchiveRadio = this.$restoreFromArchiveOption.find(".restore").on('change', () => this.setState({completeOptionSelected: false}))

        this.find(".move").click(() => {
            this.callbacks.confirmCallback({
                customer: this.state.customer,
                project: this.state.project,
                withRestore: !this.state.completeOptionSelected,
                workflowStatusId: this.state.workflowStatusId,
            })
        })
        this.find(".cancel").click(() => {
            this.callbacks.cancelCallback()
        })

        this.renderInitialState()
    }

    messageKeys() {
        return {
            moveLabel: "edit_panel.action.move",
            cancelLabel: "common.cancel",
            restoreNote: "task.list.move_to.move_to_archived.restore_target_from_archive.description",
        }
    }

    _updateDescriptionText() {
        this.$description.text(this.state.withRestoreOption ? this.state.multiOptionDescription : this.state.singleOptionDescription)
    }

    _updateRadio = (completeOptionSelected) => {
        this.$restoreFromArchiveRadio.prop('checked', !completeOptionSelected)
        this.$completeWithStatusRadio.prop('checked', completeOptionSelected)

        this.$completeWithStatusOption.toggleClass('selected', completeOptionSelected)
        this.$restoreFromArchiveOption.toggleClass('selected', !completeOptionSelected)

        this.radioStatusButton.setEditable(completeOptionSelected && this.state.canEditTaskStatus)
    }

    _createTaskStatusButton($container) {
        return new TaskStatusButton({
            editable: true,
            taskStatusMenu: new CompletedTaskStatusMenu().init(this.params.initStatusMenuTo || this.getEl()),
            showStatusTypePrefix: false,
            positionParams: {
                within: this.params.initStatusMenuTo || this.getEl(),
                collision: 'flipfit',
            },
            onStatusChangedCb: (workflowStatusId) => this.setState({
                workflowStatusId: workflowStatusId,
            })
        }).init($container)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/MoveToArchivedConfirmationDialog.js